import { ArrayUtilities, LabelMapperUtilities } from "@assets/utilities";

export enum INCOTERM_POINT {
  PLR = "PLR",
  PFD = "PFD",
  POL = "POL",
  POD = "POD",
}

export const CONTAINER_MIN_TEMP = -30;
export const CONTAINER_MAX_TEMP = 30;

export const defaultCargoTemperatureOptions =
  LabelMapperUtilities.listToSelectOptionMapper(
    ArrayUtilities.range(CONTAINER_MIN_TEMP, CONTAINER_MAX_TEMP)
  );

export const DATE_FORMAT = "dd LLL yyyy";

export const MAX_EMAIL_LENGTH = 320;

export const CELSIUS = "°C";

export const PHONE_NO_REGEX = /^[+]?[-\s.0-9]*([(][0-9]{1,4}[)])?[-\s.0-9]*$/;
